// 权限管理路由
const general: any = [
    {
        path: 'organ/list',
        name: 'outorg_list',
        meta: {
            pathTitle: 'channel_manage',
            title: '机构列表'
        },
        component: () => import('@/views/organ/list.vue')
    },
    {
        path: 'organ/organConfig',
        name: 'organConfig',
        meta: {
            pathTitle: 'outorg_list',
            title: '机构配置'
        },
        component: () => import('@/views/organ/organConfig.vue')
    },
    {
        path: 'organ/file',
        name: 'outorg_file_format',
        meta: {
            pathTitle: 'channel_manage',
            title: '文件列表'
        },
        component: () => import('@/views/organ/file.vue')
    }
]
export default general
